import React from 'react';

import { CARDS_TO_SHOW, CarouselTypes } from '../Common/Carousels/config';
import { GlobalAppCollection } from 'models/app';
import ctx from 'classnames';
import styles from '../AppCollectionCarousel/styles.module.scss';
import { SnackTile } from './snackTile';
import { CarouselWrapper, carouselWrapperConfig } from '../Common/Carousels/CarouselWrapper';
import { useTranslation } from 'react-i18next';

interface CollectionProps {
  collection: GlobalAppCollection[];
  groupName: string;
}
export const SnackCard: React.FC<CollectionProps> = ({ collection, groupName }) => {
  const { t } = useTranslation();
  let collectionGroupName = t('collectionGroup.' + groupName + '.display_name', groupName);
  let carouselWrapperConfigToBuild: carouselWrapperConfig = {
    carouselKey: CarouselTypes.Card,
    collectionDisplayName: collectionGroupName,
    carousalName: collectionGroupName,
    hideSeeAll: true,
  };
  const top3Cards: GlobalAppCollection[] = collection.slice(0, CARDS_TO_SHOW);
  carouselWrapperConfigToBuild.slidesToShow = collection.length < CARDS_TO_SHOW ? CARDS_TO_SHOW - 1 : CARDS_TO_SHOW;

  return (
    <CarouselWrapper carouselWrapperConfig={carouselWrapperConfigToBuild}>
      {top3Cards.map(collection => (
        <div className={ctx(styles.card, { [styles.col]: true })} key={collection.id} data-testid='top3Cards'>
          <SnackTile collection={collection} />
        </div>
      ))}
    </CarouselWrapper>
  );
};
